import React from 'react';
import { Button } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import Icon from '../../../../../../shared/components/Icon';
import {
  FormContent,
  FormHeader,
  FormSection,
} from '../../../../../../shared/styles';
import { IntegrationsList, StatusText } from '../styles';
import { IntegrationItemType, listOfIntegrations } from '../constants';

const Integrations = () => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const { path } = useRouteMatch();
  return (
    <>
      <FormHeader>
        <div className="left-pane">
          <div className="heading">
            {t('settings.integrations.layout.heading')} (
            {listOfIntegrations.length})
          </div>
        </div>
        <div />
      </FormHeader>
      <FormContent margin="0">
        <FormSection>
          <StatusText>{t('settings.integrations.sub_heading')}</StatusText>
          <IntegrationsList>
            {listOfIntegrations
              .slice(0, 1)
              .map((integrationItem: IntegrationItemType) => (
                <div key={integrationItem.id} className="item">
                  <Icon
                    width={integrationItem.width}
                    height={integrationItem.height}
                    glyph={integrationItem.glyph}
                  />
                  <div className="integration-name">{integrationItem.name}</div>
                  <Icon height="12" width="6" glyph="arrow-right" />
                </div>
              ))}
          </IntegrationsList>
        </FormSection>
        <FormSection maxWidth="800px">
          <StatusText>{t('settings.integrations.available')}</StatusText>
          <IntegrationsList>
            {listOfIntegrations
              .slice(1)
              .map((integrationItem: IntegrationItemType) => (
                <div key={integrationItem.id} className="item">
                  <Icon
                    width={integrationItem.width}
                    height={integrationItem.height}
                    glyph={integrationItem.glyph}
                  />
                  <div className="integration-name">{integrationItem.name}</div>
                  <Button
                    type="secondary"
                    inline
                    onClick={() => push(`${path}${integrationItem.href}`)}
                  >
                    {t('settings.integrations.connect_button')}
                  </Button>
                </div>
              ))}
          </IntegrationsList>
        </FormSection>
      </FormContent>
    </>
  );
};

export default Integrations;
